import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { FiArrowLeft } from "react-icons/fi";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { toast } from "react-toastify";
import { Editor } from "@tinymce/tinymce-react";

const MailTemplateView = () => {
  const { id } = useParams();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, fallback = "") => translations[key] || fallback;

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mail-templates/${id}`);
        setTemplate(res.data);
      } catch (err) {
        console.error("Şablon getirilemedi:", err);
        toast.error(getText("ERROR_TEMPLATE_FETCH", "Şablon getirilemedi."));
      } finally {
        setLoading(false);
      }
    };
    fetchTemplate();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{getText("LOADING", "Yükleniyor...")}</span>
        </div>
      </div>
    );
  }

  if (!template) {
    return <p className="text-center text-danger mt-4">{getText("TEMPLATE_NOT_FOUND", "Şablon bulunamadı.")}</p>;
  }

  return (
    <div className="container mt-4">
      <div className="card card-body shadow-sm position-relative">
        {/* Sağ üst köşede oluşturulma ve güncellenme tarihleri */}
        <div className="position-absolute top-0 end-0 m-3 text-end text-secondary small">
          <div>
            <strong>{getText("TABLE_CREATED_AT", "Oluşturulma Tarihi")}:</strong>{" "}
            {new Date(template.createdAt).toLocaleDateString("tr-TR")}
          </div>
          <div>
            <strong>{getText("TABLE_UPDATED_AT", "Güncellenme Tarihi")}:</strong>{" "}
            {new Date(template.updatedAt).toLocaleDateString("tr-TR")}
          </div>
        </div>

        {/* Başlık */}
        <div className="mb-4">
          <h5 className="fw-semibold mb-2">{getText("LABEL_TITLE", "Başlık")}</h5>
          <p className="mb-0" style={{ color: "#000" }}>
            {template.title}
          </p>
        </div>

        {/* İçerik-TinyMCE */}
        <div>
          <h5 className="fw-semibold mb-2">{getText("LABEL_CONTENT", "İçerik")}</h5>
          <Editor
            tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
            value={template.content}
            init={{
              height: 500,
              menubar: false,
              toolbar: false,
              plugins: [],           
              readonly: true, 
              content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MailTemplateView;
